import { setHasSeenTour as apiSetHasSeenTour,
  getUserDetails as apiGetUserDetails,
  createUserDetails as apiCreateUserDetails } from '@/utils/users-api'
import { statusEnum } from '@/utils/api-common'
import { snapOptions, snapOff } from '@/utils/constants'
import { POSSIBLE_ENGINES, DEFAULT_ENGINE } from '@/utils/search-engines'

const USER_DETAILS_KEY = '2dsearch_user_details'

function _fetchAndCreateUserDetails (doCreate) {
  apiGetUserDetails().then(r => {
    if (r.status === statusEnum.error) {
      this.showSnackbar('Unable to fetch data')
    } else if (r.status === statusEnum.notFound && doCreate) {
      apiCreateUserDetails().then(r2 => {
        if (r2.status === statusEnum.ok) {
          _fetchAndCreateUserDetails(false)
        }
      })
    } else if (r.status === statusEnum.ok && r.response && r.response.externalUser) {
      setUserDetails(r.response.externalUser)
    }
  })
}

export function fetchUserDetails () {
  _fetchAndCreateUserDetails(true)
}

export function getUserDetails () {
  const d = localStorage.getItem(USER_DETAILS_KEY)
  if (d) {
    return JSON.parse(d)
  } else {
    return null
  }
}

export function clearUserDetails () {
  return localStorage.removeItem(USER_DETAILS_KEY)
}

export function setUserDetails (userDetails) {
  localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(userDetails))
}

export function hasSeenTour () {
  const d = getUserDetails()
  if (d) {
    return d.hasSeenTour
  } else {
    return false
  }
}

export function setHasSeenTour () {
  let d = getUserDetails()
  if (typeof d === 'undefined' || d === null) {
    d = {}
  }
  d.hasSeenTour = true
  setUserDetails(d)
  apiSetHasSeenTour()
}

export function getSnapToGrid () {
  const d = getUserDetails()
  if (d && typeof d.snapToGridName !== 'undefined') {
    const e = snapOptions.find(x => {
      return x.name === d.snapToGridName
    })
    if (e) {
      return e
    }
  }
  return snapOff
}

export function getDefaultSearch () {
  const d = getUserDetails()
  if (d && typeof d.defaultSearchName !== 'undefined') {
    const e = POSSIBLE_ENGINES.find(x => {
      return x.name === d.defaultSearchName
    })
    if (e) {
      return e
    }
  }
  return DEFAULT_ENGINE
}

export function getAddQuotesAroundPhrases () {
  const d = getUserDetails()
  if (d && typeof d.addQuotesAroundPhrases !== 'undefined') {
    return d.addQuotesAroundPhrases
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/user-details.js